<template>
  <custom-dialog
    v-model="noFindFormIdVisible"
    class="judge-custom-dialog"
    :content-text="noFindFormIdText"
    cancel-button-text="返回"
    @submit="noFindFormIdSubmit"
    @close="noFindFormIdClose"
  ></custom-dialog>
</template>

<script lang="ts" setup>
  import { ref } from 'vue'
  import CustomDialog from './custom-dialog/CustomDialog.vue'
  import { useProject } from '@haohan/clw-store'

  const formPages = ref([])
  // 所有的表单页
  function getFormPages() {
    const project = useProject()
    if (project.pages?.length) {
      const flatPages = getFlatArr(project.pages)
      return flatPages
      // return flatPages.filter((page: any) => page?.variables?.pageType === 'form')
    }
    return []
  }

  function getFlatArr(arr: any) {
    return arr.reduce((a: any, item: any) => {
      let flatArr = [...a, item]
      if (item.children) {
        flatArr = [...flatArr, ...getFlatArr(item.children)]
      }
      return flatArr
    }, [])
  }

  const noFormIdTable = ref<any>({})

  const noFindFormIdVisible = ref(false)
  const noFindFormIdText = ref('')

  //移除表格绑定相关表单的按钮
  const noFindFormIdSubmit = () => {
    noFormIdTable.value.formProp.id = ''
    noFormIdTable.value.formProp.customActions = noFormIdTable.value.formProp.customActions.filter(
      (c: any) => {
        if (c.builtIn) {
          c.enabled = false
          return true
        } else if (c.event.type === 'dialog' && !c.event.pageId) {
          return false
        }
        const cur = formPages.value.find((page: any) => {
          return page.id === c.event.pageId
        })
        return cur
      }
    )
    noFindFormIdVisible.value = false
    callbackFn()
  }

  const noFindFormIdClose = () => {
    noFindFormIdVisible.value = false
  }

  //监听当前页面是否有表格，并且绑定的表单不存在在菜单列表中

  let callbackFn = null
  function judgeTableBindForm(list, callback) {
    formPages.value = getFormPages()
    callbackFn = callback
    list.forEach((item: any) => {
      if (item.type === 'HHTable') {
        let needBindForm = false
        const removeBtns = [] as any
        const cur = formPages.value.find((page: any) => {
          return page.id === item.formProp.id
        })
        item.formProp.customActions.forEach((c) => {
          if (c.builtIn) {
            //内置的按钮判断
            if (c?.enabled && !cur) {
              removeBtns.push(c.label)
              needBindForm = true
            }
          } else if (c.event.type === 'dialog') {
            //只针对弹窗类型判断表单是否存在
            if (!c.event.pageId) {
              removeBtns.push(c.label)
              needBindForm = true
            } else {
              const cur = formPages.value.find((page: any) => {
                return page.id === c.event.pageId
              })
              if (!cur) {
                removeBtns.push(c.label)
                needBindForm = true
              }
            }
          }
        })
        noFindFormIdText.value = `您的“${removeBtns.join('、')}”
          操作绑定的表单已缺失。为避免预览时发生错误，点击“确定”将删除该操作，点击“取消”可返回重新绑定。`

        if (needBindForm) {
          noFormIdTable.value = item
          noFindFormIdVisible.value = true
        }
      }
    })
    return noFindFormIdVisible.value
  }

  defineExpose({
    judgeTableBindForm
  })
</script>
